import { ValueFormat } from '@nivo/core';
import { defaultProps, DefaultRawDatum, PieLayer, ResponsivePie } from '@nivo/pie';
import React, { useState } from 'react';
import { ColorPalette } from '../../../pages/AnalysisPage/Palette/ColorPalette';
import { adjustTextColor } from '../../../pages/AnalysisPage/Palette/adjustTextColor';

export interface PieChartProps {
  data: DefaultRawDatum[];
  colors?: 'stoplight' | 'standard';
  customColorScheme?: string[];
  valueForm: ValueFormat<number>;
  height?: number;
  palette: ColorPalette;
}

export const PieChart: React.FC<PieChartProps> = ({
  data,
  colors,
  customColorScheme,
  valueForm,
  height,
  palette,
}) => {
  const [chart_loaded, set_chart_loaded] = useState(false);

  // Color scheme
  let colorScheme = [...palette.primaryScale];
  if (colors === 'stoplight') {
    colorScheme = [...palette.performanceScale];
  }
  if (!!customColorScheme?.length) {
    colorScheme = customColorScheme;
  }
  const textColor = adjustTextColor(palette, 0.85, 1);

  return (
    <div
      style={height ? { height } : undefined}
      className={`justify-center min-w-0 ${height > 0 ? '' : 'h-[500px]'}`}
      data-screenshot-id={chart_loaded ? 'chart-loaded' : undefined}
    >
      <ResponsivePie
        theme={{ fontSize: 16 }}
        data={data}
        id={'id'}
        value={'value'}
        valueFormat={valueForm}
        margin={{ top: 60, right: 80, bottom: 60, left: 80 }}
        innerRadius={0.4}
        padAngle={1}
        cornerRadius={4}
        colors={colorScheme}
        arcLinkLabelsColor={{ from: 'color' }}
        arcLabelsTextColor={textColor}
        arcLinkLabelsStraightLength={8}
        arcLabelsSkipAngle={3.6}
        arcLinkLabelsSkipAngle={3.6}
        isInteractive={false}
        layers={
          [
            ...defaultProps.layers,
            () => {
              // This is just sort of a hack to indicate that the chart has loaded, as indicated by the maker of Nivo
              // https://github.com/plouc/nivo/issues/527
              // https://codesandbox.io/s/won5y6k70w?file=/src/BarDemo.jsx:94-109
              !chart_loaded && set_chart_loaded(true);
              return <text />;
            },
          ] as PieLayer<any>[]
        }
      />
    </div>
  );
};

export default PieChart;
